import uniAdminApi from "./api";

const campusService = {
  getCampuses: async (page = 0, size = 10, search = "", status = true) => {
    const params = { page, size };
    if (search) params.search = search;
    if (status !== null && status !== undefined) params.status = status;
    const res = await uniAdminApi.get("/university-admin/campuses", { params });
    return res.data;
  },

  createCampus: async (data) => {
    const res = await uniAdminApi.post("/university-admin/campuses", data);
    return res.data;
  },

  updateCampus: async (id, data) => {
    const res = await uniAdminApi.put(`/university-admin/campuses/${id}`, data);
    return res.data;
  },

  deleteCampus: async (id) => {
    const res = await uniAdminApi.delete(`/university-admin/campuses/${id}`);
    return res.data;
  },
};

export default campusService;
